import i18next from "i18next";
import { BiEnvelope, BiPhone, BiTime } from "react-icons/bi";

import {
  About,
  CardLogo,
  CardLogosRow,
  CompanyInfoRow,
  ContactItem,
  ContactLink,
  ContactList,
  Contacts,
  ContactText,
  CopyRight,
  DeveloperLink,
  LegalInformation,
  LinkItem,
  LinksBlock,
  LogosBlock,
  Opportunities,
  PaymentsLogo,
  Socials,
  SocialsLink,
  TkpLogo,
  Wrapper,
} from "./style";

const FooterTopComponent = () => {
  const { t } = i18next;

  return (
    <>
      <Wrapper>
        <LinksBlock>
          <LegalInformation>
            <h2>{t("legal_information")}</h2>
            <div>
              <LinkItem to="/rules-of-use-info">{t("rules_of_use")}</LinkItem>
              <LinkItem to="/public-offer-info">{t("offer")}</LinkItem>
              <LinkItem to="/privacy-policy-info">{t("privacy_policy")}</LinkItem>
              <LinkItem to="/payment-info">{t("payment")}</LinkItem>
              <LinkItem to="/refund-request">{t("refund_order")}</LinkItem>
              <LinkItem to="/support">{t("support_footer_link")}</LinkItem>
            </div>
          </LegalInformation>

          <Opportunities>
            <h2>{t("opportunities")}</h2>
            <LinkItem to="/airlines">{t("airlines")}</LinkItem>
            <LinkItem to="/partners">{t("partners")}</LinkItem>
            <LinkItem to="/flights">{t("flights")}</LinkItem>
          </Opportunities>

          <About>
            <h2>{t("wannatalk")}</h2>
            <div>
              <LinkItem to="/about">{t("about_company")}</LinkItem>
              <LinkItem to="/contacts">{t("contact_information")}</LinkItem>
            </div>
            <SocialsLink>
              <LinkItem to="https://t.me/aviabozoruz" target="_blank">
                <Socials src="/socials/telegram-white.svg" alt="Telegram" />
              </LinkItem>
            </SocialsLink>
          </About>

          <Contacts>
            <h2>{t("contacts")}</h2>
            <ContactList>
              <ContactItem>
                <BiPhone />
                <div>
                  <ContactLink href="tel:+998885979009">+998 88 597 90 09</ContactLink>
                  <ContactLink href="tel:+998772979009">+998 77 297 90 09</ContactLink>
                </div>
              </ContactItem>

              <ContactItem>
                <BiEnvelope />
                <ContactLink href="mailto:ticket@aviabozor.uz">ticket@aviabozor.uz</ContactLink>
              </ContactItem>

              <ContactItem>
                <BiTime />
                <ContactText>{t("working_hours")}</ContactText>
              </ContactItem>
            </ContactList>
          </Contacts>
        </LinksBlock>

        <LogosBlock>
          <div>
            <PaymentsLogo src="/images/payment-logos.png" alt="payment-logos" />
          </div>

          <div>
            <TkpLogo src="/images/tkp-logo.png" alt="tkp-logo" />
          </div>
        </LogosBlock>
      </Wrapper>

      <CompanyInfoRow>
        ООО «BILETONLINE», ИНН 306628565, E-mail: ticket@aviabozor.uz, +998772979009, адрес: 100015, Узбекистан, город
        Ташкент, улица Хонзодабегим, 9/1
        <CopyRight>
          &copy; 2025 Aerix.dev | All rights reserved |{" "}
          <DeveloperLink href="https://aerix.dev" target="_blank" rel="noreferrer">{t("developed_by")}</DeveloperLink>
        </CopyRight>
      </CompanyInfoRow>
    </>
  );
};

export default FooterTopComponent;
